import './landing-page.scss';
import * as landingContentDirective from './landing-content.directive';

import angularTranslate from 'angular-translate';
import gazelleLocaleSelect from 'gazelle/src/components/locale-select/locale-select.module';
import gazelleAnalytics from 'gazelle/src/core/analytics/analytics.module';
import gzEula from 'gazelle/src/components/user/eula/eula.module';
import gzCarousel from 'gazelle/src/components/carousel/carousel.module';

export default angular.module('start.component.landing.content', [
  'ngMaterial',
  angularTranslate,
  gazelleAnalytics,
  gazelleLocaleSelect,
  gzEula,
  gzCarousel
])
  .directive(landingContentDirective.name, landingContentDirective.default)
  .name;



// WEBPACK FOOTER //
// ./components/landing-content/landing-content.module.js